export default __webpack_public_path__ + "static/N0009-ceaceedf1aa4cc8fb8a9c7d4dc729ed4.png";